import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Button } from "@/components/button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { useCreateExamSet } from "@/apis/exam_sets/createExamSet";
import ExamSetForm from "./components/ExamSetForm";

const ExamSetCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const {
    mutate: createExamSet,
    isPending,
    isError,
    error,
  } = useCreateExamSet();
  const [serverError, setServerError] = useState<string | undefined>();

  return (
    <PageContainer>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="flex items-center gap-4 mb-4">
          <Button plain onClick={() => navigate("/exam_sets")}>
            <ArrowLeftIcon className="h-5 w-5" />
            Back
          </Button>
          <Heading>Create New Exam Set</Heading>
        </div>
        <Text className="text-zinc-500 mb-2">
          Fill in the information below to create a new exam set.
        </Text>
        <ExamSetForm
          onSubmit={(data) => {
            createExamSet(data, {
              onSuccess: () => navigate("/exam_sets"),
              onError: (error: any) =>
                setServerError(error?.message || "Failed to create exam set"),
            });
          }}
          onCancel={() => navigate("/exam_sets")}
          isLoading={isPending}
          serverError={serverError}
        />
      </div>
    </PageContainer>
  );
};

export default ExamSetCreatePage;
